import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/MaterialIcons/unicodesMap.json';
export default createIconSet(glyphMap, 'MaterialIcons', require('~/../assets/fonts/MaterialIcons/MaterialIcons.ttf'));
